(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

},{}],2:[function(require,module,exports){
/*! js-cookie v3.0.1 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

},{}],3:[function(require,module,exports){
"use strict";

require('./app/_init');

require('./app/accordion');

require('./app/avatar');

require('./app/category');

require('./app/header');

require('./app/scroll-to-block');

require('./app/slider');

require('./app/search');

require('./app/menu-top');

require('./app/mobile-menu');

require('./app/cookies');

require('./app/glossary');

require('./app/form');

require('./app/modal');

require('./app/video');

require('./app/inputs');

require('./app/lang-switcher');

require('./app/lightbox');

require('./app/tabs');

require('./app/tags-filter');

require('./app/load-more');

require('./app/rating');

require('./app/dragscroll');

require('./app/scroll');

require('./app/scrollspy');

},{"./app/_init":4,"./app/accordion":5,"./app/avatar":6,"./app/category":7,"./app/cookies":8,"./app/dragscroll":9,"./app/form":10,"./app/glossary":11,"./app/header":12,"./app/inputs":13,"./app/lang-switcher":14,"./app/lightbox":15,"./app/load-more":16,"./app/menu-top":17,"./app/mobile-menu":18,"./app/modal":19,"./app/rating":20,"./app/scroll":22,"./app/scroll-to-block":21,"./app/scrollspy":23,"./app/search":24,"./app/slider":25,"./app/tabs":26,"./app/tags-filter":27,"./app/video":28}],4:[function(require,module,exports){
"use strict";

var body = document.querySelector('body');

if (window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident/') > 0) {
  body.classList.add('ie-browser');
}

if (navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
  body.classList.add('ios-browser');
}

if (/Android/.test(navigator.appVersion)) {
  window.addEventListener('resize', function () {
    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      document.activeElement.scrollIntoView();
    }
  });
}

},{}],5:[function(require,module,exports){
"use strict";

var expandTogglers = document.querySelectorAll('[data-toggle="expand"]');

if (expandTogglers.length) {
  expandTogglers.forEach(function (item) {
    item.addEventListener('click', function (e) {
      item.classList.toggle('active');
      var answer = e.target.closest('.accordion').querySelector('.accordion__dropdown');
      item.parentElement.classList.toggle('active');
      answer.classList.toggle('active');
    });
  });
}

},{}],6:[function(require,module,exports){
"use strict";

var name = document.querySelector('.author__name');
var abbr = document.querySelector('.author__abbr');

if (name) {
  var letters = name.innerText.split(' ').reduce(function (result, curr) {
    var firstLetter = curr[0];
    result += firstLetter;
    return result;
  }, '');

  if (abbr) {
    abbr.textContent = letters;
  }
}

},{}],7:[function(require,module,exports){
"use strict";

var _constants = require("../modules/_constants");

var _greatSelect = _interopRequireDefault(require("../modules/great-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var dcSelect = new _greatSelect["default"]('[data-select="dc"]', _constants.SELECT);
dcSelect.init();
var partnersHeader = document.querySelector('.partners__header-filter');
var select = partnersHeader === null || partnersHeader === void 0 ? void 0 : partnersHeader.querySelector('.great-select');

if (select) {
  select.addEventListener('click', function () {
    if (select.classList.contains('open')) {
      partnersHeader.classList.add('active');
    } else {
      partnersHeader.classList.remove('active');
    }
  });
}

var selectList = document.querySelector('.select__list');

if (selectList) {
  var options = selectList.querySelectorAll('.option');
  var partnersText = document.querySelector('.partners__not-found');
  options.forEach(function (option) {
    option.addEventListener('click', function () {
      var partners = document.querySelector('.partners').querySelectorAll('.partners__item');
      var partnersSearch = document.querySelectorAll('.partners__item--search');
      var category = option.getAttribute('data-value');

      if (partnersSearch) {
        partnersSearch.forEach(function (partner) {
          partner.remove();
        });
      }

      if (partners) {
        partnersText.classList.remove('show');
        partners.forEach(function (partner) {
          partner.classList.remove('show');
        });
      } else {
        partnersText.classList.add('show');
      }

      var nothing = false;

      if (!option.getAttribute('data-all')) {
        partners.forEach(function (partner) {
          if (partner.getAttribute('data-title') === category) {
            partner.classList.add('show');
            nothing = true;
          } else {
            partner.classList.remove('show');
          }
        });

        if (nothing) {
          partnersText.classList.remove('show');
        } else {
          partnersText.classList.add('show');
        }
      } else {
        partners.forEach(function (partner) {
          partner.classList.add('show');
        });
      }
    });
  });
}

},{"../modules/_constants":29,"../modules/great-select":32}],8:[function(require,module,exports){
"use strict";

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

window.onload = function () {
  var cookies = document.querySelector('#cookiesMessage');

  if (cookies) {
    cookies.querySelector('[data-toggle="cookies-accept"]').addEventListener('click', function () {
      cookies.classList.add('hide');
      setTimeout(function () {
        cookies.remove();
      }, 1000);

      _jsCookie["default"].set('vstack_cookies', 'accept', {
        expires: 365
      });
    });
  }
};

},{"js-cookie":2}],9:[function(require,module,exports){
"use strict";

/**
 * @fileoverview dragscroll - scroll area by dragging
 * @version 0.0.8
 *
 * @license MIT, see http://github.com/asvd/dragscroll
 * @copyright 2015 asvd <heliosframework@gmail.com>
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== 'undefined') {
    factory(exports);
  } else {
    factory(root.dragscroll = {});
  }
})(void 0, function (exports) {
  var _window = window;
  var _document = document;
  var mousemove = 'mousemove';
  var mouseup = 'mouseup';
  var mousedown = 'mousedown';
  var EventListener = 'EventListener';
  var addEventListener = 'add' + EventListener;
  var removeEventListener = 'remove' + EventListener;
  var newScrollX, newScrollY;
  var dragged = [];

  var reset = function reset(i, el) {
    for (i = 0; i < dragged.length;) {
      el = dragged[i++];
      el = el.container || el;
      el[removeEventListener](mousedown, el.md, 0);

      _window[removeEventListener](mouseup, el.mu, 0);

      _window[removeEventListener](mousemove, el.mm, 0);
    } // cloning into array since HTMLCollection is updated dynamically


    dragged = [].slice.call(_document.getElementsByClassName('tabs__head--horizontal'));

    for (i = 0; i < dragged.length;) {
      (function (el, lastClientX, lastClientY, pushed, scroller, cont) {
        (cont = el.container || el)[addEventListener](mousedown, cont.md = function (e) {
          if (!el.hasAttribute('nochilddrag') || _document.elementFromPoint(e.pageX, e.pageY) == cont) {
            pushed = 1;
            lastClientX = e.clientX;
            lastClientY = e.clientY;
            e.preventDefault();
          }
        }, 0);

        _window[addEventListener](mouseup, cont.mu = function () {
          pushed = 0;
        }, 0);

        _window[addEventListener](mousemove, cont.mm = function (e) {
          if (pushed) {
            (scroller = el.scroller || el).scrollLeft -= newScrollX = -lastClientX + (lastClientX = e.clientX);
            scroller.scrollTop -= newScrollY = -lastClientY + (lastClientY = e.clientY);

            if (el == _document.body) {
              (scroller = _document.documentElement).scrollLeft -= newScrollX;
              scroller.scrollTop -= newScrollY;
            }
          }
        }, 0);
      })(dragged[i++]);
    }
  };

  if (_document.readyState == 'complete') {
    reset();
  } else {
    _window[addEventListener]('load', reset, 0);
  }

  exports.reset = reset;
});

(function () {
  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    var tabs = document.querySelectorAll('.tabs__head--horizontal');
    tabs.forEach(function (item, key) {
      tabs[key].classList.add('scrollable');
    });
  }
})();

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFormDefaults = setFormDefaults;

var _constants = require("../modules/_constants");

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _modal = require("./modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import {reachGoals} from '../modules/cta-goals';
var forms = document.querySelectorAll('.form') || [];
forms.forEach(function (item) {
  var inputs = item.querySelectorAll(_constants.FORM.control);
  inputs.forEach(function (input) {
    return input.addEventListener('focus', function (e) {
      clearInputError(e.target);
    });
  });
  var inputsRequired = item.querySelectorAll("[required]");
  inputsRequired.forEach(function (input) {
    input.addEventListener("click", function () {
      if (input.classList.contains('filled')) {
        inputsRequired.forEach(function (item) {
          if (!item.classList.contains('filled')) {
            item.querySelector('.btn').setAttribute('disabled', true);
          }
        });
      }
    });
  });
  item.addEventListener('submit', function (e) {
    e.preventDefault();
    var form = e.target;
    var url = form.getAttribute('action');
    var formData = new FormData(form);
    var inputs = form.querySelectorAll(_constants.FORM.control);
    var fileInput = form.querySelector('input[type="file"]');
    var ajax = new _ajaxHandler["default"]({
      'url': url,
      'form': form
    });
    var csrfToken = document.getElementById('csrf-token');

    if (csrfToken) {
      formData.append('csrf_token', csrfToken.getAttribute('content'));
    }

    if (fileInput) {
      for (var i = 0; i < fileInput.files.length; i++) {
        formData.append('files[]', fileInput.files[i]);
      }
    }

    inputs.forEach(function (input) {
      return clearInputError(input);
    });
    ajax.send(formData, function () {
      var response = ajax.response;
      inputs.forEach(function (input) {
        return input.value = '';
      }); // reachGoals(response.counters.ym_goal, response.counters.ga_goal, response.counters.gads_goal);

      var currentModal = form.closest(_constants.MODAL.module);

      if (!currentModal) {
        (0, _modal.openModal)(_constants.MODAL.successId);
        var modalSuccess = document.getElementById(_constants.MODAL.successId);
        modalSuccess.querySelector('.modal__footer').classList.add('show');
        setFormDefaults(form);
      } else if (currentModal) {
        var currentResponse = currentModal.querySelector(_constants.MODAL.response);
        var currentFooter = currentModal.querySelector('.modal__footer');
        currentModal.querySelector(_constants.MODAL.content).classList.add('hide');
        currentResponse.classList.add('show');
        currentResponse.innerHTML = '<h3>Спасибо!<br>' + 'Мы получили ваш запрос. Наш менеджер свяжется с вами в ближайшее время.</h3>';
        currentFooter.classList.add('show');
      }
    }, function () {
      onResponseFalse(form, ajax.response);
    });
    e.preventDefault();
  });
});

function onResponseFalse(form, response) {
  var inputs = form.querySelectorAll(_constants.FORM.control);
  inputs.forEach(function (input) {
    var errorMsg = input.parentElement.querySelector(_constants.FORM.error);
    var field = input.closest(_constants.FORM.field);

    for (var error in response.errors) {
      if (input.name === response.errors[error].field && !errorMsg) {
        field.classList.add('error');
        input.classList.add('error');
        input.insertAdjacentHTML('afterend', '<span class="error-msg">' + response.errors[error].message + '</span>');
      }
    }
  });
}

function clearInputError(input) {
  var field = input.closest(_constants.FORM.field);

  if (field.classList.contains('error')) {
    var errorMsg = input.parentElement.querySelector(_constants.FORM.error);
    field.classList.remove('error');
    input.classList.remove('error');

    if (errorMsg) {
      input.parentElement.removeChild(errorMsg);
    }
  }
}

function setFormDefaults(form, modal) {
  if (modal) {
    var formResponse = modal.querySelector(_constants.MODAL.response);
    var modalContent = modal.querySelector(_constants.MODAL.content);

    if (modalContent) {
      setTimeout(function () {
        modal.querySelector(_constants.MODAL.content).classList.remove('hide');
      }, 200);
    }

    if (formResponse) {
      formResponse.innerHTML = '';
    }

    form = modal.querySelector('.form');
  }

  if (form) {
    form.querySelectorAll(_constants.FORM.control).forEach(function (input) {
      return clearInputError(input);
    });
  }
} // change back link on the success page


var fromPagePathname = localStorage.getItem('fromPage');

if (fromPagePathname) {
  var btnBack = document.querySelector('.btn--arrow-forward');
  btnBack.setAttribute('href', fromPagePathname);
  localStorage.removeItem('fromPage');
}

},{"../modules/_constants":29,"../modules/ajax-handler":31,"./modal":19}],11:[function(require,module,exports){
"use strict";

var categories = document.querySelectorAll('.glossary-link:not(.disabled)') || [];
var allItems = document.querySelectorAll('.glossary-item') || [];
var glossaryBody = document.querySelector('.glossary-body');

if (glossaryBody) {
  var minHeight;

  var glossaryListener = function glossaryListener(e, links, allItems) {
    var category = e.target.getAttribute('data-letter');
    links.forEach(function (linkInner) {
      linkInner.classList.remove('active');

      if (linkInner.getAttribute('data-letter') === category) {
        linkInner.classList.add('active');
      }
    });

    if (category !== 'all') {
      glossaryBody.classList.add('active');
      allItems.forEach(function (item) {
        item.classList.remove('active');
        item.classList.add('inactive');
      });
      setTimeout(function () {
        var activeItems = glossaryBody.querySelectorAll('[data-letter=' + category + ']');
        activeItems.forEach(function (item) {
          item.classList.remove('inactive');
          item.classList.add('active');
        });
        glossaryBody.removeAttribute('style');
        minHeight = glossaryBody.offsetHeight;
        glossaryBody.style.minHeight = minHeight + 'px';
      }, 100);
    } else {
      glossaryBody.classList.remove('active');
      allItems.forEach(function (catItem) {
        catItem.classList.remove('inactive');
        catItem.classList.add('active');
      });
      minHeight = glossaryBody.offsetHeight;
      glossaryBody.style.minHeight = minHeight + 'px';
    }

    e.preventDefault();
  };

  categories.forEach(function (link) {
    link.addEventListener('click', function (e) {
      glossaryListener(e, categories, allItems);
    });
  });
}

},{}],12:[function(require,module,exports){
"use strict";

var body = document.body;
var header = document.querySelector('.header');
var SCROLL_TOP_OFFSET = 50;
var backgroundLight = false;

if (!document.querySelector('.article__background-light')) {
  backgroundLight = true;
}

window.addEventListener('scroll', function () {
  var menu = document.querySelector('.submenu.show');

  if (window.scrollY >= SCROLL_TOP_OFFSET) {
    body.classList.add('scrolled');
    header.classList.add('header--scrolled');

    if (backgroundLight && !menu) {
      header.classList.add('header--scrolled-light');
    }
  } else {
    body.classList.remove('scrolled');
    header.classList.remove('header--scrolled');

    if (backgroundLight) {
      header.classList.remove('header--scrolled-light');
    }
  }

  if (menu) {
    header.classList.remove('header--scrolled-light');
  }
});

},{}],13:[function(require,module,exports){
"use strict";

var inputs = document.querySelectorAll('.form__control') || [];

var inputFocus = function inputFocus(e) {
  var input = e.target;
  var inputControl = input.closest('.form__field');
  inputControl.classList.add('focused');
};

var inputBlur = function inputBlur(e) {
  var input = e.target;
  var inputControl = input.closest('.form__field');
  inputControl.classList.remove('focused');
};

var inputTyping = function inputTyping(e) {
  var input = e.target;
  var inputControl = input.closest('.form__field');
  var errorMsg = inputControl.querySelector('.error-msg');
  inputControl.classList.remove('error');

  if (errorMsg) {
    errorMsg.remove();
  }
};

var btnActive = function btnActive(e) {
  if (e.target.closest('.form')) {
    var btn = e.target.closest('.form').querySelector('[type=submit]');
    var inputsRequired = e.target.closest('.form').querySelectorAll('[required]');
    inputsRequired.forEach(function (input) {
      input.addEventListener('input', function () {
        var filled = 0;
        var btnDisabled = true;
        inputsRequired.forEach(function (item) {
          if (item.value === '') {
            filled += 1;
          }
        });

        if (filled === 0) {
          btnDisabled = false;
        }

        if (btnDisabled === true) {
          btn.setAttribute('disabled', true);
        } else {
          btn.removeAttribute('disabled');
        }
      });
    });
  }
};

if (inputs.length) {
  inputs.forEach(function (item) {
    setInputListeners(item);
  });
}

function setInputListeners(input) {
  input.addEventListener('focus', inputFocus);
  input.addEventListener('blur', inputBlur);
  input.addEventListener('input', inputTyping);
  input.addEventListener('input', btnActive);
}

},{}],14:[function(require,module,exports){
"use strict";

var langSwitcher = document.querySelectorAll('[data-toggle="lang-switcher"]');
langSwitcher.forEach(function (lang) {
  lang.addEventListener('click', function () {
    lang.classList.toggle('show');
  });
});
document.addEventListener('click', function (e) {
  var target = e.target;

  if (!target.closest('.lang-switcher')) {
    langSwitcher.forEach(function (lang) {
      return lang.classList.remove('show');
    });
  }
});

},{}],15:[function(require,module,exports){
"use strict";

var _bodyScrollLock = require("body-scroll-lock");

var lightbox = document.querySelectorAll('.lightbox');
lightbox.forEach(function (item) {
  var lightboxOpen = item.querySelector('.lightbox-open');
  var lightboxClose = item.querySelector('.lightbox-close');
  var model = item.querySelector('.model__lightbox');
  lightboxOpen.addEventListener('click', function () {
    if (!model.classList.contains('show')) {
      model.classList.add('show');
    }
  });
  lightboxClose.addEventListener('click', function () {
    if (model.classList.contains('show')) {
      model.classList.remove('show');
    }
  });
});

},{"body-scroll-lock":1}],16:[function(require,module,exports){
"use strict";

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _constants = require("../modules/_constants");

var _modal = require("./modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var loadMoreBtns = document.querySelectorAll('[data-toggle="loadMore"]');

var loader = _modal.header.querySelector('.loader');

var loaderProgress = _modal.header.querySelector('.loader__progress');

var animation;
var start;

var progress = function progress(timestamp) {
  if (start === undefined) start = timestamp;
  var elapsed = timestamp - start;
  loaderProgress.style.width = elapsed / 15 + '%';

  if (elapsed < 900) {
    animation = window.requestAnimationFrame(progress);
  }
};

loadMoreBtns.forEach(function (loadMore) {
  var options = {
    'action': _constants.LOAD_MORE.action,
    'type': loadMore.dataset.type,
    'status': loadMore.dataset.status,
    'offset': loadMore.dataset.numberposts,
    'numberposts': loadMore.dataset.numberposts
  };
  loadMore.addEventListener('click', function () {
    var ajaxHandler = new _ajaxHandler["default"]({
      'url': _constants.AJAX_URL,
      'btn': loadMore
    });
    var data = new FormData();

    for (var prop in options) {
      data.append(prop, options[prop]);
    }

    data.append('category', loadMore.dataset.category);
    start = undefined;
    loaderProgress.style.width = 0;
    setTimeout(function () {
      loader.classList.add('show');
      animation = window.requestAnimationFrame(progress);
    }, 200);
    ajaxHandler.send(data, function () {
      loadMore.closest(_constants.LOAD_MORE.parent).querySelector(_constants.LOAD_MORE.container).insertAdjacentHTML('beforeend', ajaxHandler.response.cards);

      if (ajaxHandler.response) {
        window.cancelAnimationFrame(animation);
        setTimeout(function () {
          loaderProgress.style.width = '100%';
          loader.classList.remove('show');
        });
      }

      if (ajaxHandler.response.found_posts > ajaxHandler.response.post_count) {
        options.offset = ajaxHandler.response.post_count;
      } else {
        loadMore.style.display = 'none';
      }
    });
  });
});

},{"../modules/_constants":29,"../modules/ajax-handler":31,"./modal":19}],17:[function(require,module,exports){
"use strict";

var _bodyScrollLock = require("body-scroll-lock");

var dropdowns = document.querySelectorAll('[data-toggle="open-submenu"]');
var header = document.querySelector('.header');
var menuBackground = document.querySelector('.submenu__background');
var menuWrapper = document.querySelector('.submenu__wrapper');

var showMenu = function showMenu(menu, dropdown) {
  if (!menu.classList.contains('show')) {
    menu.classList.add('show');
    var height = document.querySelector('.submenu.show').clientHeight;
    dropdown.classList.add('menu__link--active');
    menuBackground.style.height = height + 'px';
    menuBackground.classList.add('show');
    menuWrapper.classList.add('show');
    header.classList.remove('header--scrolled-light');
  }
};

var hideMenu = function hideMenu(menu, drop) {
  menu.classList.remove('show');
  drop.classList.remove('menu__link--active');
  menuBackground.classList.remove('show');
};

dropdowns.forEach(function (dropdown) {
  var parent = dropdown.closest('.menu__item');
  var currentMenu = parent.querySelector('.submenu');
  var closeBtn = currentMenu.querySelector('[data-toggle="close-submenu"]');
  dropdown.addEventListener('click', function () {
    var menuShow = document.querySelector('.submenu.show');
    var dropShow = document.querySelector('[data-toggle="open-submenu"].menu__link--active');

    if (currentMenu.classList.contains('show')) {
      hideMenu(currentMenu, dropdown);
    } else if (menuShow) {
      menuShow.classList.remove('show');
      dropShow.classList.remove('menu__link--active');
      showMenu(currentMenu, dropdown);
    } else {
      showMenu(currentMenu, dropdown);
    }
  });
  dropdown.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === 'Down') {
      showMenu(currentMenu, dropdown);
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      hideMenu(currentMenu, dropdown);
    });
  }
});

var closeMenuByOuterClick = function closeMenuByOuterClick(e) {
  var menuShow = document.querySelector('.submenu.show');

  if (menuShow && !menuShow.contains(e.target) && !header.contains(e.target)) {
    document.body.classList.remove('open-modal');
    menuShow.classList.remove('show');
    document.querySelector('[data-toggle="open-submenu"].menu__link--active').classList.remove('menu__link--active');
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    menuBackground.classList.remove('show');
  }
};

window.addEventListener('click', closeMenuByOuterClick);

},{"body-scroll-lock":1}],18:[function(require,module,exports){
"use strict";

var _bodyScrollLock = require("body-scroll-lock");

var burger = document.querySelector('[data-toggle="mobile-menu"]');
var sectionToggler = document.querySelectorAll('[data-toggle="mobile-section"]');
var mobileMenuBody = document.getElementById('mobile-menu-body');
var mobileMenu = document.getElementById('mobileMenu');
var body = document.querySelector('body');
var header = document.querySelector('.header');
var menuLink = document.querySelectorAll('.mobile-menu__link');
burger.addEventListener('click', function () {
  mobileMenu.style.height = window.innerHeight + 'px';
  mobileMenu.classList.toggle('show');

  if (mobileMenu.classList.contains('show')) {
    (0, _bodyScrollLock.disableBodyScroll)(mobileMenuBody, {
      reserveScrollBarGap: true
    });
    header.classList.add('header--transparent');
  } else {
    header.classList.remove('header--transparent');
  }

  mobileMenu.querySelector('.mobile-menu').classList.toggle('show');
  body.classList.toggle('lock');
  header.classList.toggle('lock');

  if (burger.classList.contains('active')) {
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    resetMobileMenu();
  }

  burger.classList.toggle('active');
  burger.querySelector('.burgerOpen').classList.toggle('show');
  burger.querySelector('.burgerClose').classList.toggle('show');
});
sectionToggler.forEach(function (item) {
  item.addEventListener('click', function (e) {
    e.preventDefault();
    item.closest('.mobile-menu__body').classList.toggle('expanded');

    if (item.closest('.mobile-menu__body').classList.contains('expanded')) {
      menuLink.forEach(function (link) {
        if (!link.classList.contains('mobile-menu__link--section')) {
          link.style.display = 'none';
        }
      });
    } else {
      setTimeout(function () {
        menuLink.forEach(function (link) {
          link.style.display = 'initial';
        });
      }, 300);
    }

    item.classList.toggle('active');
    item.parentElement.classList.toggle('show');
    item.nextElementSibling.classList.toggle('show');
  });
});

var closeMenuByOuterClick = function closeMenuByOuterClick(e) {
  var menuShow = document.querySelector('.mobile-menu.show');

  if (menuShow && !menuShow.contains(e.target) && !burger.contains(e.target) && !header.contains(e.target)) {
    document.body.classList.remove('open-modal');
    burger.classList.remove('active');
    mobileMenu.classList.remove('show');
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    resetMobileMenu();
  }
};

var resetMobileMenu = function resetMobileMenu() {
  var sectionTogglers = document.querySelectorAll('[data-toggle="mobile-section"].active');
  var sectionsTogglersItems = document.querySelectorAll('.mobile-menu__item.show');
  var sections = document.querySelectorAll('.mobile-menu__section.show');
  sectionTogglers.forEach(function (item) {
    item.classList.remove('active');
  });
  sectionsTogglersItems.forEach(function (item) {
    item.classList.remove('show');
  });
  sections.forEach(function (item) {
    item.classList.remove('show');
  });
};

window.addEventListener('click', closeMenuByOuterClick);
var menuFooter = document.querySelector('.mobile-menu__footer');
menuFooter.querySelector('.mobile-menu__btn-wrap').addEventListener('click', function () {
  burger.querySelector('.burgerOpen').classList.add('show');
  burger.querySelector('.burgerClose').classList.remove('show');
  header.classList.remove('header--transparent');
});

},{"body-scroll-lock":1}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openModal = openModal;
exports.closeModal = closeModal;
exports.header = exports.body = void 0;

var _constants = require("../modules/_constants");

var _functions = require("../modules/_functions");

var _form = require("./form");

var _bodyScrollLock = require("body-scroll-lock");

var openButtons = document.querySelectorAll('[data-toggle="modal"]') || [];
var closeButtons = document.querySelectorAll('[data-toggle="close-modal"]') || [];
var body = document.querySelector('body');
exports.body = body;
var header = document.querySelector('.header');
exports.header = header;
var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

function closePopupByOuterClick(event) {
  if (!event.target.closest(_constants.MODAL.window) && !(event.target.getAttribute('data-toggle') === 'modal')) {
    closeModal();
  }
}

function openModal(id) {
  var modal = document.getElementById(id);
  modal.dispatchEvent(new CustomEvent('modal:beforeOpen'));

  if (!(0, _functions.isMobileDevice)()) {
    body.classList.add('lock');
    body.style.paddingRight = scrollbarWidth + 'px';
    header.style.right = scrollbarWidth + 'px';
  }

  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.disableBodyScroll)(modal, {
      reserveScrollBarGap: true
    });
  }

  setTimeout(function () {
    modal.classList.add('show');

    if (modal.querySelector('.modal__response').classList.contains('show')) {
      modal.querySelector('.modal__footer').classList.add('show');
    }

    document.addEventListener('mousedown', closePopupByOuterClick);
  }, 200);
}

function closeModal(modal) {
  modal = modal ? modal : document.querySelector('.modal.show');
  modal.classList.add('out');

  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.enableBodyScroll)(modal);
  }

  setTimeout(function () {
    (0, _form.setFormDefaults)(false, modal);
    modal.classList.remove('show');
    modal.querySelector('.modal__response').classList.remove('show');
    modal.querySelector('.modal__footer').classList.remove('show');
    modal.classList.remove('out');
    body.classList.remove('lock');
    body.style.paddingRight = null;
    header.style.right = null;
  }, 200);
  document.removeEventListener('mousedown', closePopupByOuterClick);
}

openButtons.forEach(function (btn) {
  return btn.addEventListener('click', function (e) {
    e.preventDefault();
    var target = this.getAttribute('data-target').replace('#', '');
    openModal(target);
  });
});
closeButtons.forEach(function (btn) {
  return btn.addEventListener('click', function () {
    return closeModal();
  });
});
document.addEventListener('keydown', function (event) {
  var modal = document.querySelector('.modal.show');

  if (event.key === 'Escape' && modal) {
    closeModal(modal);
  }
});

},{"../modules/_constants":29,"../modules/_functions":30,"./form":10,"body-scroll-lock":1}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStars = clearStars;

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _constants = require("../modules/_constants");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var stars = document.querySelectorAll('.stars-block:not(.disabled)');
var rateCount = document.querySelector('.rate-count');

if (rateCount && rateCount.textContent === '') {
  rateCount.innerText = 1;
}

stars.forEach(function (starsElement) {
  var starItems = starsElement.querySelectorAll('.stars-block__item');
  starsElement.addEventListener('mouseleave', starsMouseLeaveHandler);
  starItems.forEach(function (starItem) {
    starItem.addEventListener('mousemove', mouseMoveHandler);
    starItem.addEventListener('click', function () {
      var currRating = starsElement.closest('.rating');
      var input = currRating.querySelector('input[data-id="rating"]');
      var currValue = document.querySelector('[data-set-rating]');
      var text = starItem.dataset.text;
      input.value = starItem.dataset.rate;

      if (text) {
        starItem.setAttribute('voted', text);
        setTimeout(function () {
          return starItem.removeAttribute('voted');
        }, 0);
      }

      if (currValue) {
        currValue.innerHTML = starItem.dataset.rate;
      }

      var parent = starItem.closest('.rating');
      var state = {
        id: parent.dataset.id,
        type: parent.dataset.type,
        rating: starItem.dataset.rate
      };
      starsAjax(state);
    });
  });

  var starsAjax = function starsAjax(state) {
    var ajax = new _ajaxHandler["default"]({
      'url': _constants.AJAX_URL,
      'form': starsElement
    });
    var data = new FormData();
    data.append('action', _constants.RATING.action);
    data.append('csrf_token', document.getElementById('csrf-token').getAttribute('content'));
    data.append('type', state.type);
    data.append('id', state.id);
    data.append('rating', state.rating);
    data.append('page', window.location.href.split('?')[0]);
    ajax.send(data, function () {
      var response = ajax.response;

      if (response.status === 'success') {
        _jsCookie["default"].set('rated-post-' + state.id, state.rating, {
          expires: 365,
          path: '/'
        });

        document.querySelectorAll('.stars-block__item').forEach(function (star) {
          star.setAttribute('disabled', true);

          if (star.dataset.text) {
            star.setAttribute('tooltip', star.dataset.text);
          }
        });
        var newRateCount = Number(rateCount.textContent) + 1;
        var rateAverage = document.querySelector('.average-rate');
        var newAverage = Number(rateAverage.textContent) * Number(rateCount.textContent) + Number(state.rating);
        newAverage = Math.round(newAverage / newRateCount * 10) / 10;
        rateCount.innerText = newRateCount;
        rateAverage.innerText = newAverage;
      }
    });
  };
});

function starsMouseLeaveHandler() {
  var ratingInput = this.closest('.rating').querySelector('input[data-id="rating"]');
  clearStars(this, false, ratingInput.value);
}

function mouseMoveHandler(e) {
  var rating = +this.dataset.rate;
  var starItems = this.closest('.stars-block').querySelectorAll('.stars-block__item');
  starItems.forEach(function (star) {
    var starOverlay = star.querySelector('.star-elem--inner');

    if (rating >= +star.dataset.rate) {
      starOverlay.style.width = '100%';
      starOverlay.classList.add('star-elem--full');
    } else {
      starOverlay.style.width = '0';
      starOverlay.classList.remove('star-elem--full');
    }
  });
}

function clearStars(stars, modal) {
  var currentRating = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var starsElement = stars ? stars : modal.querySelector('.stars-block');

  if (starsElement) {
    var starsItems = starsElement.querySelectorAll('.stars-block__item');
    starsItems.forEach(function (starItem) {
      var star = starItem.querySelector('.star-elem--inner');

      if (Number(starItem.dataset.rate) <= Number(currentRating)) {
        star.classList.add('star-elem--full');
      } else {
        star.classList.remove('star-elem--full');
      }
    });
    var input = starsElement.closest('.rating').querySelector('input[data-id="rating"]');
    input.value = currentRating;
  }
}

},{"../modules/_constants":29,"../modules/ajax-handler":31,"js-cookie":2}],21:[function(require,module,exports){
"use strict";

var btns = document.querySelectorAll('[data-toggle="scrollToBlock"]');
btns.forEach(function (btn) {
  var OFFSET = 100;
  btn.addEventListener('click', function (evt) {
    evt.preventDefault();
    var targetBlock = document.getElementById('events-form');

    if (targetBlock) {
      var top = window.scrollY + targetBlock.getBoundingClientRect().top - OFFSET;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  });
});

},{}],22:[function(require,module,exports){
"use strict";

var _scrollTo = _interopRequireDefault(require("../modules/scrollTo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var asideLinks = document.querySelectorAll('.aside-menu__link');

if (asideLinks) {
  asideLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = '#' + link.getAttribute('data-target');
      document.querySelector('.aside-menu__link.active').classList.remove('active');
      link.classList.add('active');
      (0, _scrollTo["default"])(target, 1000);
      e.preventDefault();
    });
  });
}

},{"../modules/scrollTo":33}],23:[function(require,module,exports){
"use strict";

var targets = document.querySelectorAll('*[id^="rt-"]');
var sections = {};
var i = 0;
targets.forEach(function (target) {
  return !sections[target.id] ? sections[target.id] = target.getBoundingClientRect().top + window.scrollY - document.querySelector('.header').getBoundingClientRect().height - 500 : '';
});

if (document.querySelector('.anchor-spy')) {
  window.onscroll = function () {
    var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

    for (i in sections) {
      if (sections[i] <= scrollPosition) {
        document.querySelector('.anchor-spy.active').classList.remove('active');
        document.querySelector('a[href*=' + i + ']').classList.add('active');
      }
    }
  };
}

},{}],24:[function(require,module,exports){
"use strict";

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _constants = require("../modules/_constants");

var _modal = require("./modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var searchTogglers = document.querySelectorAll('.partners__header-icon');

var loader = _modal.header.querySelector('.loader');

var loaderProgress = _modal.header.querySelector('.loader__progress');

var selectedFilter = '';
var animation;
var start;

var progress = function progress(timestamp) {
  if (start === undefined) start = timestamp;
  var elapsed = timestamp - start;
  loaderProgress.style.width = elapsed / 15 + '%';

  if (elapsed < 900) {
    animation = window.requestAnimationFrame(progress);
  }
};

var partnersFilter = document.querySelector('.partners__header-filter');

if (partnersFilter) {
  var options = partnersFilter.querySelectorAll('.option');
  options.forEach(function (option) {
    option.addEventListener('click', function () {
      document.querySelector('.search-modal__input').value = '';

      if (option.classList.contains('active') && !option.getAttribute('data-all')) {
        selectedFilter = option.getAttribute('data-value');
      } else {
        selectedFilter = '';
      }
    });
  });
}

searchTogglers.forEach(function (search) {
  document.querySelector('.partners__not-found').classList.remove('show');
  var inputParent = search.closest('.search-modal__form');
  var input = inputParent.querySelector('.form__control');
  var options = {
    'action': _constants.SEARCH.action
  };
  input.addEventListener('input', function () {
    input.setAttribute('value', input.value);
    options.query = input.value;
    options.filter = selectedFilter;
  });
  input.addEventListener('keydown', function (e) {
    if (e.keyCode === 13) {
      var ajaxHandler = new _ajaxHandler["default"]({
        'url': _constants.AJAX_URL
      });
      var data = new FormData();

      for (var prop in options) {
        data.append(prop, options[prop]);
      }

      setTimeout(function () {
        loader.classList.add('show');
        animation = window.requestAnimationFrame(progress);
      }, 200);
      ajaxHandler.send(data, function () {
        var partners = document.querySelectorAll('.partners__item');

        if (partners) {
          partners.forEach(function (item) {
            item.classList.remove('show');
          });
        }

        if (ajaxHandler.response.cards) {
          document.querySelector('.partners__not-found').classList.remove('show');
          search.closest(_constants.SEARCH.parent).querySelector(_constants.SEARCH.container).insertAdjacentHTML('beforeend', ajaxHandler.response.cards);
          window.cancelAnimationFrame(animation);
          setTimeout(function () {
            loaderProgress.style.width = '100%';
            loader.classList.remove('show');
          });
        } else {
          document.querySelector('.partners__not-found').classList.add('show');
        }
      });
    }
  });
  search.addEventListener('click', function () {
    var ajaxHandler = new _ajaxHandler["default"]({
      'url': _constants.AJAX_URL
    });
    var data = new FormData();

    for (var prop in options) {
      data.append(prop, options[prop]);
    }

    setTimeout(function () {
      loader.classList.add('show');
      animation = window.requestAnimationFrame(progress);
    }, 200);
    ajaxHandler.send(data, function () {
      var partners = document.querySelectorAll('.partners__item');

      if (partners) {
        partners.forEach(function (item) {
          item.classList.remove('show');
        });
      }

      if (ajaxHandler.response.cards) {
        document.querySelector('.partners__not-found').classList.remove('show');
        search.closest(_constants.SEARCH.parent).querySelector(_constants.SEARCH.container).insertAdjacentHTML('beforeend', ajaxHandler.response.cards);
        window.cancelAnimationFrame(animation);
        setTimeout(function () {
          loaderProgress.style.width = '100%';
          loader.classList.remove('show');
        });
      } else {
        document.querySelector('.partners__not-found').classList.add('show');
        window.cancelAnimationFrame(animation);
        setTimeout(function () {
          loaderProgress.style.width = '100%';
          loader.classList.remove('show');
        });
      }
    });
  });
});

},{"../modules/_constants":29,"../modules/ajax-handler":31,"./modal":19}],25:[function(require,module,exports){
"use strict";

var sliderBlock = document.querySelectorAll('.slider');
var tickerBlock = document.querySelectorAll('.tickers');

if (sliderBlock.length) {
  Array.prototype.forEach.call(sliderBlock, function (block) {
    var slider = new Siema({
      selector: '.siema',
      duration: 300,
      perPage: {
        0: 1,
        768: 2,
        1200: 3
      }
    });
    block.querySelector('.prev').addEventListener('click', function () {
      return slider.prev();
    });
    block.querySelector('.next').addEventListener('click', function () {
      return slider.next();
    });
  });
}

if (tickerBlock.length) {
  Array.prototype.forEach.call(tickerBlock, function () {
    var ticker = new Siema({
      selector: '.ticker',
      duration: 2000,
      easing: 'linear',
      perPage: {
        0: 2,
        576: 3,
        768: 4,
        1200: 6
      },
      rtl: false,
      loop: true
    });
    setInterval(function () {
      return ticker.next();
    }, 2000);
  });
}

},{}],26:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var tabs = document.querySelectorAll('.tabs');

var tabsBodyHeight = function tabsBodyHeight() {
  tabs.forEach(function (currentTabs) {
    var tabsPaneActive = currentTabs.querySelector('.tabs__pane.active').getBoundingClientRect().height;
    var tabsCard = currentTabs.querySelector('.card');

    if (tabsCard) {
      var paddingTopTabsCard = Number(getComputedStyle(tabsCard, null).paddingTop.split('px')[0]);
      var paddingBottomTabsCard = Number(getComputedStyle(tabsCard, null).paddingBottom.split('px')[0]);
      tabsCard.style.height = tabsPaneActive + paddingTopTabsCard + paddingBottomTabsCard + 'px';
    }
  });
};

window.addEventListener('resize', tabsBodyHeight);
tabs.forEach(function (tab) {
  var tabControls = tab.querySelectorAll('[data-tab-toggle]') || [];
  var tabTogglers = tab.querySelectorAll('.tabs__link');
  var tabsBody = tab.querySelector('.tabs__body');
  var panes = tab.querySelectorAll('.tabs__pane');
  var title = tab.querySelectorAll('.tabs__title');

  if (panes.length) {
    panes[0].classList.add('active');
  }

  if (title.length) {
    title[0].classList.add('active');
  }

  if (tabTogglers.length) {
    tabTogglers[0].classList.add('active');
  }

  var changeTab = function changeTab(direction) {
    direction = direction ? direction : 'next';

    var activeTabIndex = _toConsumableArray(panes).findIndex(function (item) {
      return item.classList.contains('active');
    });

    var nextTabIndex = direction === 'prev' ? (activeTabIndex + panes.length - 1) % panes.length : (activeTabIndex + 1) % panes.length;
    var nextTab = panes[nextTabIndex];

    if (nextTab) {
      panes[activeTabIndex].classList.remove('active');
      panes[nextTabIndex].classList.add('active');

      if (title.length) {
        title[activeTabIndex].classList.remove('active');
        title[nextTabIndex].classList.add('active');
      }

      if (tabTogglers.length) {
        tabTogglers[activeTabIndex].classList.remove('active');
        tabTogglers[nextTabIndex].classList.add('active');
      }

      tabsBodyHeight();
    }
  };

  tabControls.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      var direction = item.getAttribute('data-tab-toggle');
      tabsBodyHeight();
      changeTab(direction);
    });
  });
  tabTogglers.forEach(function (toggler) {
    var changeTabByToggler = function changeTabByToggler() {
      var targetValue = toggler.getAttribute('data-tab');
      var target = tabsBody.querySelectorAll('[data-tab-pane=' + targetValue + ']');
      tabTogglers.forEach(function (toggler) {
        return toggler.classList.remove('active');
      });
      panes.forEach(function (pane) {
        return pane.classList.remove('active');
      });
      toggler.classList.add('active');

      if (target) {
        target.forEach(function (pane) {
          return pane.classList.add('active');
        });
      }

      tabsBodyHeight();
    };

    toggler.addEventListener('click', changeTabByToggler);
    toggler.addEventListener('keydown', function (e) {
      return e.key === 'Enter' && changeTabByToggler();
    });
  });
});

},{}],27:[function(require,module,exports){
"use strict";

var filters = document.querySelectorAll('.filter');

if (filters) {
  var tags = document.querySelectorAll('.tags__link');
  filters.forEach(function (filter) {
    document.addEventListener('DOMContentLoaded', function () {
      filter.querySelectorAll('.filter__item').forEach(function (item) {
        return item.classList.add('show');
      });
    });
  });
  tags.forEach(function (tag) {
    tag.addEventListener('click', function (e) {
      var filterClass = e.target.dataset['filter'];
      document.querySelector('.tags__link.active').classList.remove('active');
      tag.classList.add('active');
      document.querySelectorAll('.filter__item').forEach(function (elem) {
        var filters = elem.dataset['filter'].split(', ');
        elem.classList.remove('show');
        var border = elem.closest('.faq-block__border');

        if (border) {
          border.style.display = 'none';
          border.classList.remove('show');
        }

        if (filters.includes(filterClass) || filterClass === 'all') {
          elem.classList.add('show');

          if (border) {
            border.style.display = '';
            border.classList.add('show');
          }
        }
      });

      if (document.querySelectorAll('.faq-block__border.show').length === 1) {
        document.querySelector('.faq-block__border').classList.remove('show');
      }

      document.querySelectorAll('.faq-block__main').forEach(function (elem) {
        if (filterClass !== 'all' && filterClass !== elem.dataset.title) {
          elem.classList.remove('show');
          elem.style.display = 'none';
        } else {
          elem.classList.add('show');
          elem.style.display = '';
        }
      });
    });
  });
}

},{}],28:[function(require,module,exports){
"use strict";

var trigger = document.querySelectorAll('[data-toggle="video-trigger"]');

if (trigger) {
  trigger.forEach(function (item) {
    item.addEventListener('click', function () {
      var wrap = item.closest('.video');
      var frame = wrap.querySelector('.video__frame');
      var video = wrap.querySelector('.video__item');
      item.style.display = 'none';
      video.style.display = 'block';
      frame.style.display = 'block'; // video.previousElementSibling.style.display = 'none';

      if (video.tagName === 'video') {
        video.play();
      } else {
        video.src += "?autoplay=1";
      }
    });
  });
}

},{}],29:[function(require,module,exports){
"use strict";

module.exports = Object.freeze({
  AJAX_URL: '/wp/wp-admin/admin-ajax.php',
  LOAD_MORE: {
    action: 'load_more',
    parent: '.load-wrapper',
    container: '.load-container'
  },
  RATING: {
    action: 'set_rating'
  },
  SEARCH: {
    action: 'search',
    parent: '.search-wrapper',
    container: '.search__container'
  },
  FORM: {
    field: '.form__field',
    control: '.form__control',
    error: '.error-msg'
  },
  MODAL: {
    module: '.modal',
    window: '.modal__popup',
    content: '.modal__content',
    response: '.modal__response',
    footer: '.modal__footer',
    successId: 'modal-success'
  },
  SELECT: {
    classes: {
      'main': 'select',
      'list': 'select__list',
      'current': 'select__current',
      'optionSelected': 'active'
    }
  },
  HOURS_IN_MONTH: 720,
  SUCCESS_PAGE: '/success/'
});

},{}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileDevice = isMobileDevice;
exports.inViewport = inViewport;
exports.getSiblings = getSiblings;
exports.numberThousandSeparator = numberThousandSeparator;
exports.isDomElement = isDomElement;
exports["default"] = void 0;

/**
 * @param {String} data
 *
 * @return {String}
 */
var _default = Element.prototype.data = function (data) {
  return this.getAttribute('data-' + data);
};
/**
 * @return {Boolean}
 */


exports["default"] = _default;

function isMobileDevice() {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
}
/**
 * @param {Element} element
 *
 * @return {Boolean}
 */


function inViewport(element) {
  return !(element.getBoundingClientRect().top > innerHeight || element.getBoundingClientRect().bottom < 0);
}
/**
 * @param {Element} element
 *
 * @return {Array}
 */


function getSiblings(element) {
  return Array.prototype.filter.call(element.parentNode.children, function (sibling) {
    return sibling !== element;
  });
}
/**
 * @param {Number} n
 *
 * @return {String}
 */


function numberThousandSeparator(n) {
  return n.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
}
/**
 * @param {Element} element
 *
 * @return {Boolean}
 */


function isDomElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
}

},{}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AjaxHandler = /*#__PURE__*/function () {
  function AjaxHandler(options) {
    _classCallCheck(this, AjaxHandler);

    this.options = options;
    this.form = this.options.form;
    this.loader = this.form ? this.form.querySelector('.form-loader') : null;
    this.btn = this.form ? this.form.querySelector('button[type="submit"]') : this.options.btn ? this.options.btn : null;
  }

  _createClass(AjaxHandler, [{
    key: "onResponseSuccess",
    value: function onResponseSuccess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onResponseFalse",
    value: function onResponseFalse(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onAjaxHandlerProcess",
    value: function onAjaxHandlerProcess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "send",
    value: function send(data, callbackSuccess, callbackFalse, callbackProcess) {
      var _this = this;

      // Event to modify data before ajax sending
      var beforeSubmitEvent;
      var xhr = new XMLHttpRequest();

      if (this.form) {
        beforeSubmitEvent = new CustomEvent('ajax:beforeSubmit', {
          'detail': {
            formData: data
          }
        });
        this.form.dispatchEvent(beforeSubmitEvent);
      }

      xhr.open('POST', this.options.url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(beforeSubmitEvent ? beforeSubmitEvent.detail.formData : data);

      this._disableBtn();

      this._loadingBtn();

      this._showLoader();

      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          setTimeout(function () {
            var response;

            _this._hideLoader();

            try {
              response = JSON.parse(xhr.responseText);
            } catch (e) {
              response = xhr.responseText;
            } // this._enableBtn();


            _this._activateBtn();

            _this.response = response;

            if (response.status === 'error') {
              _this.onResponseFalse(callbackFalse);
            } else {
              _this.onResponseSuccess(callbackSuccess);
            }
          }, 1000);
        }
      };
    }
  }, {
    key: "_disableBtn",
    value: function _disableBtn() {
      if (this.btn) {
        this.btn.setAttribute('disabled', 'disabled');
      }
    }
  }, {
    key: "_enableBtn",
    value: function _enableBtn() {
      if (this.btn) {
        this.btn.removeAttribute('disabled');
      }
    }
  }, {
    key: "_hideLoader",
    value: function _hideLoader() {
      if (this.loader) {
        this.loader.style.display = 'none';
      }
    }
  }, {
    key: "_showLoader",
    value: function _showLoader() {
      if (this.loader) {
        this.loader.style.display = 'block';
      }
    }
  }, {
    key: "_loadingBtn",
    value: function _loadingBtn() {
      if (this.btn) {
        this.btn.classList.add('loading');
      }
    }
  }, {
    key: "_activateBtn",
    value: function _activateBtn() {
      if (this.btn) {
        this.btn.classList.remove('loading');
      }
    }
  }]);

  return AjaxHandler;
}();

var _default = AjaxHandler;
exports["default"] = _default;

},{}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GreatSelect = /*#__PURE__*/function () {
  /**
   * @param {String} itemsSelector
   * @param {Object} options
   */
  function GreatSelect(itemsSelector, options) {
    _classCallCheck(this, GreatSelect);

    this.classes = {
      'main': 'great-select',
      'opened': 'open',
      'disabled': 'disabled',
      'list': 'list',
      'option': 'option',
      'current': 'current',
      'optionSelected': 'selected',
      'optionFocused': 'focus'
    };

    if (options && options.classes) {
      for (var optionClass in options.classes) {
        this.classes[optionClass] = options.classes[optionClass];
      }
    }

    this.selectItems = document.querySelectorAll(itemsSelector);
  }

  _createClass(GreatSelect, [{
    key: "init",
    value: function init() {
      var _this = this;

      //this._removeListeners();
      GreatSelect._iePointerEventsFix();

      this.selectItems.forEach(function (item) {
        var nextElement = item.nextElementSibling;
        item.style.display = 'none';

        if (!nextElement || nextElement && !nextElement.classList.contains(_this.classes.main)) {
          _this._createSelect(item);
        }
      });

      this._addGlobalListeners();
    }
  }, {
    key: "_createSelect",
    value: function _createSelect(selectItem) {
      var _this2 = this;

      var selectDisabled = selectItem.getAttribute('disabled');
      var selectContainer = '<div class="' + this.classes.main + ' great-select ' + (selectItem.getAttribute('class') || '') + (selectDisabled ? this.classes.disabled : '') + '" ' + '' + (!selectDisabled ? 'tabindex="0"' : '') + '>' + '<span class="' + this.classes.current + '"></span>' + '<ul class="' + this.classes.list + '"></ul>' + '</div>';
      selectItem.insertAdjacentHTML('afterend', selectContainer);
      var dropdown = selectItem.nextElementSibling;
      var options = selectItem.querySelectorAll('option');
      var selectedOption = selectItem.querySelector('option:checked');
      var optionsContainer = dropdown.querySelector('ul');
      var icon = selectedOption.getAttribute('data-select-icon');
      var selectedOptionBadge = selectedOption.getAttribute('data-select-badge');
      dropdown.querySelector('.' + this.classes.current).innerHTML = "".concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', " <span ").concat(selectedOptionBadge ? 'class="disabled"' : '', ">").concat(selectedOption.getAttribute('data-display') || selectedOption.getAttribute('data-shorter-name') || selectedOption.textContent, "</span> ").concat(selectedOptionBadge ? "<span class=\"select__badge select__badge--current\">".concat(selectedOptionBadge, "</span>") : '');
      options.forEach(function (option) {
        var displayText = option.getAttribute('data-display');
        var shorterName = option.getAttribute('data-shorter-name');
        var icon = option.getAttribute('data-select-icon');
        var badge = option.getAttribute('data-select-badge');
        var optionItem = "<li data-value=\"".concat(option.value, "\" ").concat(icon ? "data-select-icon=\"".concat(icon, "\"") : '', " \n          ").concat(option.getAttribute('data-all') ? 'data-all="all"' : '', "\n          ").concat(displayText ? 'data-display="' + displayText + '"' : '', "\n          ").concat(shorterName ? 'data-shorter-name="' + shorterName + '"' : '', "\n          class=\"").concat(_this2.classes.option, " ").concat(option.selected ? _this2.classes.optionSelected : '', " ").concat(option.disabled ? _this2.classes.disabled : '', "\">\n          ").concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', "\n          <span>").concat(option.textContent, "</span>\n          ").concat(badge ? "<span class=\"select__badge\">".concat(badge, "</span>") : '', "\n          </li>");
        optionsContainer.insertAdjacentHTML('beforeend', optionItem);
      });

      this._addSelectListeners(selectItem.nextElementSibling, selectItem.previousElementSibling);
    }
  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      var allSelects = document.querySelectorAll('.' + this.classes.main);
      allSelects.forEach(function (select) {
        var clone = select.cloneNode(true);
        select.parentNode.replaceChild(clone, select);
      });
    }
  }, {
    key: "_addSelectListeners",
    value: function _addSelectListeners(gSelectItem, label) {
      var _this3 = this;

      gSelectItem.addEventListener('click', function (e) {
        var dropdown = e.target.closest('.' + _this3.classes.main);
        document.querySelectorAll('.' + _this3.classes.main).forEach(function (item) {
          if (item !== dropdown) {
            item.classList.remove(_this3.classes.opened);
          }
        });
        dropdown.classList.toggle(_this3.classes.opened);

        if (dropdown.classList.contains(_this3.classes.opened)) {
          var focusedOption = dropdown.querySelector('.' + _this3.classes.optionFocused);

          if (focusedOption) {
            focusedOption.classList.remove(_this3.classes.optionFocused);
          }

          dropdown.querySelector('.' + _this3.classes.optionSelected).classList.add(_this3.classes.optionFocused);
        } else {
          dropdown.focus();
        }
      });
      var activeOptions = gSelectItem.querySelectorAll('.' + this.classes.option + ':not(.' + this.classes.disabled + ')');
      activeOptions.forEach(function (option) {
        return option.addEventListener('click', function (e) {
          var targetOption = e.target.closest('.' + _this3.classes.option);
          var icon = option.getAttribute('data-select-icon');
          var badge = option.getAttribute('data-select-badge');
          gSelectItem.querySelector('.' + _this3.classes.optionSelected).classList.remove(_this3.classes.optionSelected);
          targetOption.classList.add(_this3.classes.optionSelected);
          gSelectItem.querySelector('.' + _this3.classes.current).innerHTML = "".concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', " ").concat(targetOption.getAttribute('data-display') || targetOption.getAttribute('data-shorter-name') || targetOption.textContent, " ").concat(badge ? "<span class=\"select__badge\">".concat(badge, "</span>") : '');
          gSelectItem.previousElementSibling.value = targetOption.getAttribute('data-value');
          gSelectItem.previousElementSibling.dispatchEvent(new CustomEvent('change'));
        });
      });
      gSelectItem.addEventListener('keydown', function (e) {
        var targetDropdown = e.target.closest('.' + _this3.classes.main);
        var focusedOption = targetDropdown.querySelector('.' + _this3.classes.optionFocused) || targetDropdown.querySelector('.' + _this3.classes.option + '.' + _this3.classes.optionSelected);

        if (e.code === 'Space' || e.code === 'Enter') {
          e.preventDefault();

          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            focusedOption.click();
          } else {
            targetDropdown.click();
          }
        } else if (e.code === 'ArrowDown') {
          e.preventDefault();

          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find next not disabled
            //var $next = $focused_option.nextAll('.option:not(.disabled)').first();
            // let nextAll = false;
            // nextAll = [].filter.call(focusedOption.parentNode.children,  elem => {
            //     return (elem.previousElementSibling === focusedOption) ? nextAll = true : nextAll;
            // });
            var next = focusedOption.nextElementSibling;

            if (next) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              next.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'ArrowUp') {
          e.preventDefault();

          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find prev not disabled
            var prev = focusedOption.previousElementSibling;

            if (prev) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              prev.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'Escape') {
          targetDropdown.classList.remove(_this3.classes.opened);
        } else if (e.code === 'Tab') {
          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            e.preventDefault();
          }
        }
      });

      if (label) {
        label.addEventListener('click', function () {
          gSelectItem.focus();
        });
      }
    }
  }, {
    key: "_addGlobalListeners",
    value: function _addGlobalListeners() {
      var _this4 = this;

      document.addEventListener('click', function (e) {
        var openedSelect = document.querySelector('.' + _this4.classes.main + '.' + _this4.classes.opened);

        if (openedSelect && !openedSelect.contains(e.target)) {
          openedSelect.classList.remove(_this4.classes.opened);
        }
      });
    }
  }, {
    key: "update",
    value: function update() {
      var _this5 = this;

      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;
        var opened = dropdown.classList.contains(_this5.classes.opened);

        if (dropdown && dropdown.classList.contains(_this5.classes.main)) {
          dropdown.remove();

          _this5._createSelect(select);

          if (opened) {
            select.nextElementSibling.click();
          }
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;

      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;

        if (dropdown && dropdown.classList.contains(_this6.classes.main)) {
          dropdown.remove();
          select.style.display = '';
        }
      });
    }
  }], [{
    key: "_iePointerEventsFix",
    value: function _iePointerEventsFix() {
      // Detect CSS pointer-events support, for IE <= 10. From Modernizr.
      var style = document.createElement('a').style;
      style.cssText = 'pointer-events:auto';

      if (style.pointerEvents !== 'auto') {
        document.querySelector('html').classList.add('no-csspointerevents');
      }
    }
  }]);

  return GreatSelect;
}();

exports["default"] = GreatSelect;

},{}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;

var _functions = require("./_functions");

function scrollTo(element, duration) {
  if (element && ((0, _functions.isDomElement)(element) || document.querySelector(element))) {
    var OFFSET = 50;
    var target = (0, _functions.isDomElement)(element) ? element : document.querySelector(element);
    var startingY = window.pageYOffset;
    var elementY = window.pageYOffset + target.getBoundingClientRect().top;
    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY - document.querySelector('.header').getBoundingClientRect().height - OFFSET;
    var diff = targetY - startingY; // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294

    var easing = function easing(t) {
      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };

    var start;

    if (diff) {
      // Bootstrap our animation - it will get called right before next frame shall be rendered.
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) {
          start = timestamp;
        }

        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        percent = easing(percent);
        window.scrollTo(0, startingY + diff * percent);

        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    }
  }
}

},{"./_functions":30}]},{},[3]);
